import type { App } from 'vue'
import { registerComponents } from './components'
import { STAGE_ROUTES } from './model/stage'

export { type BadgeTone, statusTone } from './model/status'

export const createDeliverables = () => ({
  install: (app: App) => {
    registerComponents(app)
    app.getRouter().addRoute('organization', {
      path: 'deliverables/:deliverableId',
      name: 'deliverable-editor',
      meta: {
        bare: true,
        head: { titleKey: 'deliverables.editor.title' }
      },
      component: () => import('./pages/DeliverableEditorPage.vue'),
      // A stage route renders nothing of its own: the editor page reads the stage from the route name.
      children: [
        { path: 'copy', name: STAGE_ROUTES.copy, components: {} },
        { path: 'canvas', name: STAGE_ROUTES.canvas, components: {} }
      ]
    })
  }
})
